import { render } from "./TasksArchive.vue?vue&type=template&id=f46aa672"
import script from "./TasksArchive.vue?vue&type=script&lang=js"
export * from "./TasksArchive.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__